import React from 'react';

const Pricing = ({ language }) => {
  const content = {
    en: {
      title: 'Choose Your Plan',
      subtitle: 'Flexible pricing for choirs of all sizes',
      plans: [
        {
          name: 'Starter',
          price: '500 SEK',
          period: '/year',
          features: ['Home page', 'Photo albums', 'Information page', 'Member page', 'Officials page', 'One language', 'Only admin can log in'],
          popular: false
        },
        {
          name: 'Professional',
          price: '800 SEK',
          period: '/year',
          features: ['Domain name', 'Calendar', 'Attendance page', 'Media page', 'forScore page', 'Email lists', 'All members can log in'],
          popular: true
        },
        {
          name: 'Enterprise',
          price: '1000 SEK',
          period: '/year',
          features: ['Board page', 'Multiple languages'],
          popular: false
        }
      ],
      selectPlan: 'Select Plan',
      mostPopular: 'Most Popular'
    },
    es: {
      title: 'Elige Tu Plan',
      subtitle: 'Precios flexibles para coros de todos los tamaños',
      plans: [
        {
          name: 'Inicial',
          price: '500 SEK',
          period: '/año',
          features: ['Página de inicio', 'Álbumes de fotos', 'Página de información', 'Página de miembros', 'Página de oficiales', 'Un idioma', 'Solo el administrador puede iniciar sesión'],
          popular: false
        },
        {
          name: 'Profesional',
          price: '800 SEK',
          period: '/año',
          features: ['Nombre de dominio', 'Calendario', 'Página de asistencia', 'Página de medios', 'Página de forScore', 'Listas de correo electrónico', 'Todos los miembros pueden iniciar sesión'],
          popular: true
        },
        {
          name: 'Empresarial',
          price: '1000 SEK',
          period: '/año',
          features: ['Página de la junta', 'Múltiples idiomas'],
          popular: false
        }
      ],
      selectPlan: 'Seleccionar Plan',
      mostPopular: 'Más Popular'
    },
    sv: {
      title: 'Välj Din Plan',
      subtitle: 'Flexibla priser för körer av alla storlekar',
      plans: [
        {
          name: 'Start',
          price: '500 SEK',
          period: '/år',
          features: ['Hemsida', 'Fotoalbum', 'Informationssida', 'Medlemssida', 'Funktionärssida', 'Ett språk', 'Endast admin kan logga in'],
          popular: false
        },
        {
          name: 'Professionell',
          price: '800 SEK',
          period: '/år',
          features: ['Domännamn', 'Kalender', 'Närvarosida', 'Mediasida', 'forScore-sida', 'E-postlistor', 'Alla medlemmar kan logga in'],
          popular: true
        },
        {
          name: 'Företag',
          price: '1000 SEK',
          period: '/år',
          features: ['Styrelsesida', 'Flera språk'],
          popular: false
        }
      ],
      selectPlan: 'Välj Plan',
      mostPopular: 'Mest Populär'
    }
  };

  const t = content[language];

  return (
    <div className="container">
      <div style={{ textAlign: 'center', color: 'white', padding: '2rem 0' }}>
        <h1>{t.title}</h1>
        <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>{t.subtitle}</p>
      </div>
      
      <div className="pricing-cards">
        {t.plans.map((plan, index) => (
          <div key={index} className="pricing-card" style={{ position: 'relative' }}>
            {plan.popular && (
              <div style={{
                position: 'absolute',
                top: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#667eea',
                color: 'white',
                padding: '0.5rem 1rem',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: 'bold'
              }}>
                {t.mostPopular}
              </div>
            )}
            <h3>{plan.name}</h3>
            <div className="price">
              {plan.price}<span style={{ fontSize: '1rem', fontWeight: 'normal' }}>{plan.period}</span>
            </div>
            <ul style={{ textAlign: 'left', margin: '1rem 0' }}>
              {plan.features.map((feature, i) => (
                <li key={i} style={{ margin: '0.5rem 0' }}>✓ {feature}</li>
              ))}
            </ul>
            <button className="cta-button" style={{ width: '100%', marginTop: '1rem' }}>
              {t.selectPlan}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pricing;